import React from 'react'
import { makeStyles } from 'tss-react/mui'
import type { Theme } from '@mui/material/styles'

export type FormItemProps = {
  children: any
  /**
   * 上辺に区切り線
   */
  borderTop?: boolean
  /**
   * 下辺に区切り線
   */
  borderBottom?: boolean
  /**
   * コンテンツの
   */
  align?: 'left' | 'center' | 'right'
  className?: string
}

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
    width: '100%',
  },
  center: { justifyContent: 'center' },
  left: { justifyContent: 'flex-start' },
  right: { justifyContent: 'flex-end' },
  borderTop: {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  borderBottom: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}))

/**
 * paddingを持つ積み重ねコンテンツ
 */
export const Stack: React.FC<FormItemProps> = ({
  children,
  borderTop,
  borderBottom,
  align,
  className,
}: FormItemProps) => {
  const { classes, cx } = useStyles()

  return (
    <>
      <div
        className={cx(
          classes.root,
          borderTop && classes.borderTop,
          borderBottom && classes.borderBottom,
          align && classes[align],
          className && className
        )}
      >
        {children}
      </div>
    </>
  )
}
Stack.defaultProps = {
  align: 'left',
}

export default Stack
